{
  "v5.m2.annuler": "Cancel",
  "v5.m2.anomalie.anomalie": "the defect",
  "v5.m2.anomalie.aucune_campagne": "No campaign.",
  "v5.m2.anomalie.aucune_preuve": "No green run of the linked case after the resolution.",
  "v5.m2.anomalie.campagne": "Campaign",
  "v5.m2.anomalie.campagne_a_choisir": "Choose a campaign to see eligible runs.",
  "v5.m2.anomalie.campagnes": "the campaigns",
  "v5.m2.anomalie.choisir": "Choose…",
  "v5.m2.anomalie.consulter_execution": "View the run",
  "v5.m2.anomalie.echec": "The state change failed.",
  "v5.m2.anomalie.enregistrer_examen": "Record the review",
  "v5.m2.anomalie.etat.closed": "closed",
  "v5.m2.anomalie.etat.duplicate": "duplicate",
  "v5.m2.anomalie.etat.in_progress": "in progress",
  "v5.m2.anomalie.etat.new": "new",
  "v5.m2.anomalie.etat.not_reproducible": "not reproducible",
  "v5.m2.anomalie.etat.rejected": "rejected",
  "v5.m2.anomalie.etat.reopened": "reopened",
  "v5.m2.anomalie.etat.resolved": "resolved",
  "v5.m2.anomalie.etat.triaged": "triaged",
  "v5.m2.anomalie.etat.verified": "verified",
  "v5.m2.anomalie.examinee": "Review recorded: the defect is verified.",
  "v5.m2.anomalie.execution": "Run proving the fix",
  "v5.m2.anomalie.executions": "the runs",
  "v5.m2.anomalie.fermee": "Defect closed.",
  "v5.m2.anomalie.fermer": "Close the defect",
  "v5.m2.anomalie.observation": "Observation",
  "v5.m2.anomalie.observation_requise": "An observation is required for the review.",
  "v5.m2.anomalie.pas_resolue": "The defect is not resolved.",
  "v5.m2.anomalie.pas_verifiee": "The defect must be verified first.",
  "v5.m2.anomalie.preuve_aide": "Distinct from the green run: delivered version, deployment or publication.",
  "v5.m2.anomalie.preuve_livraison": "Delivery evidence",
  "v5.m2.anomalie.preuve_requise": "Delivery evidence is required to close.",
  "v5.m2.anomalie.refaire": "Run again",
  "v5.m2.anomalie.resolue_par": "Resolved by {{qui}} on {{le}}.",
  "v5.m2.anomalie.resolveur": "You resolved this defect: someone else verifies it.",
  "v5.m2.anomalie.sans_anomalie": "No defect is selected: open this dialog from a defect.",
  "v5.m2.anomalie.titre": "Verify then close a defect",
  "v5.m2.code.ACCESS_DENIED": "Access to this action is denied.",
  "v5.m2.code.CAS_DEJA_EN_QUARANTAINE": "This case is already quarantined.",
  "v5.m2.code.CAS_PAS_EN_QUARANTAINE": "This case is not quarantined.",
  "v5.m2.code.CONTEXTE_INCOMPLET": "The decision context is incomplete.",
  "v5.m2.code.CREATEUR_N_APPROUVE_PAS": "The author cannot decide on their own work.",
  "v5.m2.code.DEFECT_TRANSITION_FORBIDDEN": "This state change is not allowed.",
  "v5.m2.code.DEFECT_VERIFICATION_REQUIRES_GREEN_EXECUTION": "A green run of the linked case, after the resolution, is required.",
  "v5.m2.code.DEFECT_VERIFIER_NOT_INDEPENDENT": "The person who resolved the defect cannot verify it.",
  "v5.m2.code.DROIT_NON_TENU": "You do not hold the right this action requires.",
  "v5.m2.code.HITL_SOD_AUTHOR_CANNOT_DECIDE": "The tool proposer cannot decide it.",
  "v5.m2.code.MISSION_ALREADY_PAUSED": "The mission is already paused.",
  "v5.m2.code.MISSION_ALREADY_SUSPENDED": "The mission is already suspended.",
  "v5.m2.code.MISSION_DECISION_ALREADY_TAKEN": "This decision has already been taken.",
  "v5.m2.code.MISSION_ESCALATION_BUDGET_EXHAUSTED": "The mission reopening budget is exhausted.",
  "v5.m2.code.MISSION_NOT_AWAITING_APPROVAL": "The mission is not awaiting a decision.",
  "v5.m2.code.MISSION_NOT_PAUSED": "The mission is not paused.",
  "v5.m2.code.MISSION_NOT_RUNNING": "The mission is not running.",
  "v5.m2.code.MISSION_TASK_NOT_FOUND": "This task does not belong to the mission.",
  "v5.m2.code.NOT_FOUND": "Not found in this project.",
  "v5.m2.code.RELECTEUR_NE_DECIDE_PAS": "The reviewer does not decide.",
  "v5.m2.code.SELF_APPROVAL_REFUSED": "The mission launcher cannot decide it.",
  "v5.m2.code.SOD_VIOLATION": "The suite author cannot run it: ask another member.",
  "v5.m2.code.TOOL_EXECUTION_ALREADY_DECIDED": "This tool execution is already decided.",
  "v5.m2.code.TOOL_EXECUTION_NOT_FOUND": "Tool execution request not found.",
  "v5.m2.code.VALIDATION_ERROR": "The input was refused: check the fields.",
  "v5.m2.decider.approuver": "Approve",
  "v5.m2.decider.approuver_plan": "Approve the plan",
  "v5.m2.decider.approuver_replan": "Approve the new split",
  "v5.m2.decider.consommation": "Budget: {{minutes}} compute min, {{consomme}} min used.",
  "v5.m2.decider.decide": "Decision recorded.",
  "v5.m2.decider.decider_partiellement": "Deliver converged tasks",
  "v5.m2.decider.decider_suite": "Decide the next step",
  "v5.m2.decider.dossier_non_servi": "The dossier is not served: it cannot be approved blindly.",
  "v5.m2.decider.echec": "The decision could not be recorded.",
  "v5.m2.decider.empreinte": "Reviewed fingerprint: {{empreinte}}",
  "v5.m2.decider.irreversible": "The decision is logged and cannot be undone.",
  "v5.m2.decider.lanceur": "You launched this mission: another authorised person decides.",
  "v5.m2.decider.partielle": "Partial decision: delivered tasks {{livres}}, abandoned tasks {{annules}}.",
  "v5.m2.decider.partielle_refusee": "Partial delivery impossible: conditions not met.",
  "v5.m2.decider.portee": "Scope: mission “{{mission}}” ({{taches}} tasks).",
  "v5.m2.decider.refuser": "Reject",
  "v5.m2.decider.refuser_plan": "Reject the plan",
  "v5.m2.decider.refuser_replan": "Reject the new split",
  "v5.m2.decider.resolution_dossier": "Dossier resolution",
  "v5.m2.decider.rien_a_decider": "This mission is not awaiting a decision.",
  "v5.m2.decider.suite.abandonner": "Abandon",
  "v5.m2.decider.suite.decider_le_dossier": "Decide the dossier",
  "v5.m2.decider.suite.libelle": "Next step",
  "v5.m2.decider.suite.prendre_acte_et_clore": "Acknowledge and close",
  "v5.m2.decider.suite.replanifier": "Replan",
  "v5.m2.decider.tache_exclue": "A task’s next step is decided from the task page.",
  "v5.m2.decider.titre": "Decide a mission plan or dossier",
  "v5.m2.decider.version.deja_decide": "nothing to decide",
  "v5.m2.decider.version.dossier": "mission dossier to decide",
  "v5.m2.decider.version.nouveau_decoupage": "proposed new split",
  "v5.m2.decider.version.plan_initial": "proposed initial plan",
  "v5.m2.decider.version.suite": "stops to handle",
  "v5.m2.decider.version_relue": "Reviewed version",
  "v5.m2.ecran_non_realise": "“{{ecran}}” leads to a screen that is not available yet.",
  "v5.m2.etape.aucun": "No event.",
  "v5.m2.etape.aucun_de_l_etape": "No event for this step.",
  "v5.m2.etape.cible": "Target",
  "v5.m2.etape.cible_absente": "No target received.",
  "v5.m2.etape.cible_recue": "Mission {{mission}}, task {{tache}}, step {{etape}}.",
  "v5.m2.etape.etape": "Step",
  "v5.m2.etape.etape_recue": "Received step: {{etape}}",
  "v5.m2.etape.evenements": "Step events",
  "v5.m2.etape.flux.connecte": "Stream connected.",
  "v5.m2.etape.flux.connexion": "Connecting to the stream…",
  "v5.m2.etape.flux.deconnecte": "Stream disconnected.",
  "v5.m2.etape.flux.erreur": "The stream failed.",
  "v5.m2.etape.flux.refus": "Stream access denied.",
  "v5.m2.etape.incoherence": "The job target differs from the received target: the received one is kept.",
  "v5.m2.etape.reconnecter": "Reconnect",
  "v5.m2.etape.retour_journal": "Back to the log ({{filtre}})",
  "v5.m2.etape.sans_correlation": "{{nombre}} events without mission, task or step identifiers.",
  "v5.m2.etape.tache": "Task page",
  "v5.m2.etape.titre": "Events of a task step",
  "v5.m2.etape.traitement": "the job",
  "v5.m2.etape.traitement_complet": "Full job",
  "v5.m2.etape.traitement_etat": "Job {{id}} — {{statut}}",
  "v5.m2.etat.chargement": "Loading: {{quoi}}…",
  "v5.m2.etat.en_cours": "In progress…",
  "v5.m2.etat.erreur": "Could not read: {{quoi}}.",
  "v5.m2.etat.introuvable": "Not found: {{quoi}}.",
  "v5.m2.etat.reessayer": "Retry",
  "v5.m2.etat.refus": "Access denied: {{quoi}}.",
  "v5.m2.executer.approuver_outil": "Approve the execution",
  "v5.m2.executer.bloquee": "Step blocked: prerequisites missing.",
  "v5.m2.executer.commentaire": "Comment",
  "v5.m2.executer.echec": "The step could not be started.",
  "v5.m2.executer.enfilee": "Step queued ({{traitement}}).",
  "v5.m2.executer.environnement_docker": "Docker environment",
  "v5.m2.executer.etape": "Step",
  "v5.m2.executer.etape_inconnue": "Step “{{etape}}” is not in the project process.",
  "v5.m2.executer.executer": "Run",
  "v5.m2.executer.modele": "Template {{modele}}, version {{version}} (fixed).",
  "v5.m2.executer.outil_decide": "Tool decision recorded.",
  "v5.m2.executer.outil_demande": "Tool {{outil}}, proposed by {{auteur}}.",
  "v5.m2.executer.outil_echec": "The tool decision failed.",
  "v5.m2.executer.outil_ia": "AI tool execution",
  "v5.m2.executer.pipeline": "Project pipeline",
  "v5.m2.executer.plan": "the project process",
  "v5.m2.executer.prerequis_complets": "Prerequisites met.",
  "v5.m2.executer.reference_gitlab": "GitLab reference",
  "v5.m2.executer.rejeter_outil": "Reject the execution",
  "v5.m2.executer.resultat": "Expected result: {{nature}}.",
  "v5.m2.executer.sans_etape": "No step is selected: open this dialog from a step.",
  "v5.m2.executer.titre": "Run a project step",
  "v5.m2.executer.version": "Version to deploy",
  "v5.m2.fermer": "Close",
  "v5.m2.fiche_tache.aucune_tentative": "No attempt.",
  "v5.m2.fiche_tache.avis": "{{nombre}} review opinions (advice only, no effect).",
  "v5.m2.fiche_tache.avis_absent": "No review opinion.",
  "v5.m2.fiche_tache.decider": "Decide the next step",
  "v5.m2.fiche_tache.empreinte": "Fingerprint: {{empreinte}}",
  "v5.m2.fiche_tache.etape_inconnue": "Step not identified.",
  "v5.m2.fiche_tache.etat_resultat.echec_demarrage": "start failure",
  "v5.m2.fiche_tache.etat_resultat.echoue": "failed",
  "v5.m2.fiche_tache.etat_resultat.non_mesure": "not measured",
  "v5.m2.fiche_tache.etat_resultat.reussi": "passed",
  "v5.m2.fiche_tache.evenements_etape": "Step events",
  "v5.m2.fiche_tache.non_mesure": "No measured result.",
  "v5.m2.fiche_tache.origine": "Origin of the next step",
  "v5.m2.fiche_tache.origine_absente": "No decision restarted this task.",
  "v5.m2.fiche_tache.origine_decision": "Restarted by {{decideur}} ({{resolution}}) on {{le}}.",
  "v5.m2.fiche_tache.piece_absente": "No browser failure evidence.",
  "v5.m2.fiche_tache.preuves": "Evidence",
  "v5.m2.fiche_tache.preuves_non_deposees": "Evidence not filed.",
  "v5.m2.fiche_tache.resultat": "Round {{tour}} — {{type}}",
  "v5.m2.fiche_tache.resultats": "Results",
  "v5.m2.fiche_tache.retour_mission": "Back to the mission",
  "v5.m2.fiche_tache.suite_suspecte": "Suspect test suite: {{motifs}}",
  "v5.m2.fiche_tache.tentative": "Round {{tour}} — {{type}} ({{caste}})",
  "v5.m2.fiche_tache.tentatives": "Attempts",
  "v5.m2.fiche_tache.titre": "Mission task and evidence",
  "v5.m2.fiche_tache.traitement": "View the job",
  "v5.m2.mission.libelle": "the mission",
  "v5.m2.motif": "Reason",
  "v5.m2.motif_court": "The reason must be at least {{min}} characters.",
  "v5.m2.motif_requis": "A reason is required.",
  "v5.m2.partage.actif": "Active until {{echeance}}",
  "v5.m2.partage.aucun_lien": "No share link.",
  "v5.m2.partage.cree": "Link created: {{chemin}}",
  "v5.m2.partage.creer": "Create the link",
  "v5.m2.partage.duree": "Duration (hours)",
  "v5.m2.partage.duree_aide": "{{defaut}} h by default, {{max}} h at most.",
  "v5.m2.partage.duree_invalide": "Enter a whole number of hours, at least {{min}}.",
  "v5.m2.partage.echec": "The link could not be created.",
  "v5.m2.partage.expire": "Expired on {{echeance}}",
  "v5.m2.partage.liens": "Share links",
  "v5.m2.partage.ouvrir": "Open link {{id}}",
  "v5.m2.partage.plafond": "The duration exceeds the {{max}} h cap.",
  "v5.m2.partage.portee.connexion": "The link requires signing in.",
  "v5.m2.partage.portee.expiration": "The link expires at the chosen time.",
  "v5.m2.partage.portee.jeton": "The link carries no token.",
  "v5.m2.partage.portee.membres": "Only active project members can open it.",
  "v5.m2.partage.portee.revocable": "The link can be revoked.",
  "v5.m2.partage.revoque": "Revoked (due {{echeance}})",
  "v5.m2.partage.titre": "Share a preview",
  "v5.m2.piloter.arreter": "Stop",
  "v5.m2.piloter.confirmer_effet": "The current step finishes, then the mission stops for good.",
  "v5.m2.piloter.confirmer_titre": "Stop mission “{{mission}}”?",
  "v5.m2.piloter.deja_terminee": "The mission has ended.",
  "v5.m2.piloter.echec": "The request failed.",
  "v5.m2.piloter.effets": "The current step finishes; nothing else starts while the mission is suspended or stopped.",
  "v5.m2.piloter.etat": "Mission state",
  "v5.m2.piloter.etat.en_cours": "running",
  "v5.m2.piloter.etat.ia_interrompue": "suspended by the tool",
  "v5.m2.piloter.etat.suspendu": "paused",
  "v5.m2.piloter.etat.termine": "ended",
  "v5.m2.piloter.fait": "Request recorded.",
  "v5.m2.piloter.pas_en_cours": "The mission is not running.",
  "v5.m2.piloter.pas_en_pause": "The mission is not paused.",
  "v5.m2.piloter.reprendre": "Resume",
  "v5.m2.piloter.reprise_automatique": "The tool will resume the mission when the resource is available.",
  "v5.m2.piloter.suspendre": "Suspend",
  "v5.m2.piloter.titre": "Control a mission run",
  "v5.m2.retours.aucun": "No feedback.",
  "v5.m2.retours.aucune_generation": "No generation.",
  "v5.m2.retours.generation": "Generation",
  "v5.m2.retours.generations": "the generations",
  "v5.m2.retours.liste": "Feedback",
  "v5.m2.retours.note": "Rating {{note}} of 5",
  "v5.m2.retours.nouveau": "New feedback",
  "v5.m2.retours.ouvrir": "Open feedback {{id}}",
  "v5.m2.retours.sans_commentaire": "No comment",
  "v5.m2.retours.titre": "Feedback on generations",
  "v5.m2.retours.toutes": "All",
  "v5.m2.revision.acces": "Live previews: {{vivants}} of {{plafond}}; port pool {{pool}}.",
  "v5.m2.revision.acces_libelle": "access",
  "v5.m2.revision.apercus": "Previews of the revision",
  "v5.m2.revision.application": "Application",
  "v5.m2.revision.aucun_apercu": "No preview of this revision.",
  "v5.m2.revision.aucune_autre": "No other revision of this application.",
  "v5.m2.revision.base": "Base revision",
  "v5.m2.revision.capture": "the capture",
  "v5.m2.revision.capture_absente": "No capture.",
  "v5.m2.revision.capture_alt": "Capture of screen {{ecran}} at {{largeur}} px",
  "v5.m2.revision.carte": "Card",
  "v5.m2.revision.comparaison_echec": "The comparison failed.",
  "v5.m2.revision.comparer": "Compare",
  "v5.m2.revision.comparer_titre": "Compare two revisions",
  "v5.m2.revision.date": "Date",
  "v5.m2.revision.demarre": "Preview requested ({{id}}).",
  "v5.m2.revision.demarrer": "Start a preview",
  "v5.m2.revision.ecarts": "Screens identical {{identical}}, changed {{changed}}, removed {{removed}}, added {{added}}.",
  "v5.m2.revision.echec": "The preview could not start.",
  "v5.m2.revision.effets": "Starts application {{application}} at exactly revision {{revision}}.",
  "v5.m2.revision.empreinte": "Fingerprint",
  "v5.m2.revision.existant": "A live preview of this revision already exists.",
  "v5.m2.revision.identite": "Revision identity",
  "v5.m2.revision.introuvable": "This revision was not found for the chosen application.",
  "v5.m2.revision.libelle": "the revisions",
  "v5.m2.revision.modele": "Model",
  "v5.m2.revision.non_previsualisable": "This revision did not pass its checks.",
  "v5.m2.revision.origine": "Origin",
  "v5.m2.revision.origine.generation": "generation",
  "v5.m2.revision.origine.mission": "mission",
  "v5.m2.revision.ouvrir_apercu": "Open the preview",
  "v5.m2.revision.plafond": "The project live preview cap is reached.",
  "v5.m2.revision.publication": "Code publication",
  "v5.m2.revision.releve": "Survey",
  "v5.m2.revision.releve_absent": "No survey for this revision.",
  "v5.m2.revision.releve_resume": "{{ecrans}} screens, {{routes}} routes surveyed.",
  "v5.m2.revision.revision": "Revision",
  "v5.m2.revision.titre": "Trial version revision",
  "v5.m2.sans_projet": "No project is selected: open this screen from a project.",
  "v5.m2.suite.ajouter_etape": "Add a step",
  "v5.m2.suite.aucune_execution": "No run.",
  "v5.m2.suite.auteur": "Defined by {{qui}} on {{le}}.",
  "v5.m2.suite.auteur_n_execute_pas": "You defined this suite: another member runs it.",
  "v5.m2.suite.commande_etape": "Step {{rang}} command",
  "v5.m2.suite.confirmer_effet": "{{nombre}} commands will run in order.",
  "v5.m2.suite.confirmer_titre": "Run suite “{{suite}}”?",
  "v5.m2.suite.creation": "Define the commands in the order they will run.",
  "v5.m2.suite.creee": "Suite created.",
  "v5.m2.suite.creer": "Create the suite",
  "v5.m2.suite.echec_creation": "The suite could not be created.",
  "v5.m2.suite.echec_execution": "The run could not be requested.",
  "v5.m2.suite.effets": "{{nombre}} commands run in order on the project environment.",
  "v5.m2.suite.executee": "Run requested (no. {{execution}}).",
  "v5.m2.suite.executer": "Run the suite",
  "v5.m2.suite.executions": "Runs",
  "v5.m2.suite.introuvable": "Command suite not found.",
  "v5.m2.suite.libelle": "the suite",
  "v5.m2.suite.nom": "Suite name",
  "v5.m2.suite.nom_etape": "Step {{rang}} name",
  "v5.m2.suite.nom_invalide": "The name only takes letters, digits, spaces, dots, dashes and underscores (120 max).",
  "v5.m2.suite.nom_requis": "The name is required.",
  "v5.m2.suite.ouvrir_execution": "Open the run",
  "v5.m2.suite.relais": "You do not hold the command definition right: ask a member who holds it.",
  "v5.m2.suite.relais_lien": "See project members",
  "v5.m2.suite.relais_membre": "Ask another member",
  "v5.m2.suite.requis": "Required.",
  "v5.m2.suite.retour": "Back to suites",
  "v5.m2.suite.statut.done": "done",
  "v5.m2.suite.statut.failed": "failed",
  "v5.m2.suite.statut.pending": "running",
  "v5.m2.suite.statut.skipped": "skipped",
  "v5.m2.suite.titre": "Command suite details",
  "v5.m2.suite.titre_creation": "New command suite",
  "v5.m2.suites.aucune": "No command suite.",
  "v5.m2.suites.creer": "Create a suite",
  "v5.m2.suites.etapes": "{{nombre}} steps",
  "v5.m2.suites.liste": "Project suites",
  "v5.m2.suites.preparer": "Prepare a suite",
  "v5.m2.suites.relais": "Creating a suite requires the command definition right: ask a member who holds it.",
  "v5.m2.suites.titre": "Command suites",
  "v5.m2.supervision.actions": "Actions",
  "v5.m2.supervision.agent": "Agent",
  "v5.m2.supervision.agents": "Running agents",
  "v5.m2.supervision.agregation": "Aggregation",
  "v5.m2.supervision.aucun_executant": "No running agent.",
  "v5.m2.supervision.aucune_mission": "No mission.",
  "v5.m2.supervision.consommation": "Compute consumption",
  "v5.m2.supervision.depuis": "Since",
  "v5.m2.supervision.dernier_signal": "Last signal",
  "v5.m2.supervision.erreur": "Error",
  "v5.m2.supervision.executant_a_choisir": "Choose an agent to see its run.",
  "v5.m2.supervision.execution": "Run",
  "v5.m2.supervision.journal": "Job log",
  "v5.m2.supervision.lancer_mission": "Launch a mission",
  "v5.m2.supervision.ligne_caste": "{{caste}}: {{tours}} rounds",
  "v5.m2.supervision.ligne_mission": "{{mission}}: {{consomme}} min used of {{estime}} estimated",
  "v5.m2.supervision.ligne_tache": "Task {{rang}} — {{titre}}: {{tours}} rounds, {{estime}} min estimated",
  "v5.m2.supervision.ligne_tours": "{{tours}} rounds used (cap {{plafond}} per task).",
  "v5.m2.supervision.mission": "Mission",
  "v5.m2.supervision.mission_a_choisir": "Choose a mission for this aggregation.",
  "v5.m2.supervision.missions": "the missions",
  "v5.m2.supervision.non_instrumente": "Consumption traces not instrumented.",
  "v5.m2.supervision.ouvrir_mission": "Open the mission",
  "v5.m2.supervision.statut": "Status",
  "v5.m2.supervision.statut.error": "in error",
  "v5.m2.supervision.statut.idle": "idle",
  "v5.m2.supervision.statut.running": "running",
  "v5.m2.supervision.titre": "Agent supervision",
  "v5.m2.supervision.toutes": "All",
  "v5.m2.supervision.voir_executant": "View executor {{agent}}",
  "v5.m2.supervision.vue.par_caste": "By caste",
  "v5.m2.supervision.vue.par_mission": "By mission",
  "v5.m2.supervision.vue.par_tache": "By task",
  "v5.m2.supervision.vue.par_tour": "By round",
  "v5.m2.tache.cible": "Target task",
  "v5.m2.tache.confirmer": "Confirm the next step",
  "v5.m2.tache.consommation": "Compute used by the task: {{secondes}} s.",
  "v5.m2.tache.decider_titre": "Decide the next step of a stopped task",
  "v5.m2.tache.effet.accept_stop": "The task’s work is discarded; dependent tasks are listed.",
  "v5.m2.tache.effet.other_family": "Work done is kept; another model family takes over.",
  "v5.m2.tache.effet.redesign_tests": "Tests are redesigned before a new attempt.",
  "v5.m2.tache.effet.reorient": "Work done is kept; a new attempt opens.",
  "v5.m2.tache.effet.take_over": "Work done is kept; a person takes over the task.",
  "v5.m2.tache.lanceur": "You launched the mission: an authorised third party decides.",
  "v5.m2.tache.libelle": "the task",
  "v5.m2.tache.limites": "Reopenings so far: {{reouvertures}}; escalations left: {{restantes}}.",
  "v5.m2.tache.motif_arret": "Stop reason: {{motif}}",
  "v5.m2.tache.pas_en_attente": "The task is not awaiting a decision.",
  "v5.m2.tache.portee": "Mission “{{mission}}”, task {{tache}} (fixed).",
  "v5.m2.tache.portee_limitee": "The decision applies to this task only, never to the whole mission.",
  "v5.m2.tache.rang": "Task {{rang}} — {{titre}}",
  "v5.m2.tache.relais_tiers": "Ask an authorised member",
  "v5.m2.tache.reouverture_epuisee": "The reopening budget is exhausted: take over or acknowledge.",
  "v5.m2.tache.statut.cancelled": "cancelled",
  "v5.m2.tache.statut.pending": "pending",
  "v5.m2.tache.statut.ready": "ready",
  "v5.m2.tache.statut.running": "running",
  "v5.m2.tache.statut.stopped": "stopped",
  "v5.m2.tache.statut.succeeded": "done",
  "v5.m2.tache.suite": "Next step for the task",
  "v5.m2.tache.suite.autre_famille": "Other model family",
  "v5.m2.tache.suite.prendre_acte_de_l_arret": "Acknowledge the stop",
  "v5.m2.tache.suite.prendre_la_main": "Take over",
  "v5.m2.tache.suite.reconcevoir_les_tests": "Redesign the tests",
  "v5.m2.tache.suite.reorienter": "Reorient",
  "v5.m2.tests.acceptee": "accepted",
  "v5.m2.tests.accepter": "Accept the regression",
  "v5.m2.tests.anomalie_liee": "Linked defect",
  "v5.m2.tests.aucun_cas": "No test case.",
  "v5.m2.tests.aucun_essai": "No off-campaign run.",
  "v5.m2.tests.aucun_plan": "No test plan.",
  "v5.m2.tests.aucune_campagne": "No campaign.",
  "v5.m2.tests.aucune_quarantaine": "No quarantined test.",
  "v5.m2.tests.aucune_reference": "No eligible reference campaign.",
  "v5.m2.tests.aucune_regression": "No regression.",
  "v5.m2.tests.aucune_suite": "No plan is designated as the regression suite.",
  "v5.m2.tests.campagne.cancelled": "cancelled",
  "v5.m2.tests.campagne.closed": "closed",
  "v5.m2.tests.campagne.open": "open",
  "v5.m2.tests.campagne_courante": "Current campaign",
  "v5.m2.tests.campagne_terminee": "The campaign has ended.",
  "v5.m2.tests.campagnes": "the campaigns",
  "v5.m2.tests.cas": "the cases",
  "v5.m2.tests.choisir": "Choose…",
  "v5.m2.tests.choisir_campagne": "Choose a current campaign.",
  "v5.m2.tests.comparaison_impossible": "Comparison impossible for this campaign.",
  "v5.m2.tests.couverture": "Coverage",
  "v5.m2.tests.declarer": "Report a defect",
  "v5.m2.tests.demarrer_essai": "Start a run",
  "v5.m2.tests.designer_suite": "Designate the suite",
  "v5.m2.tests.en_quarantaine": "quarantined",
  "v5.m2.tests.essai.cancelled": "cancelled",
  "v5.m2.tests.essai.failed": "failed",
  "v5.m2.tests.essai.passed": "passed",
  "v5.m2.tests.essai.running": "running",
  "v5.m2.tests.essais": "the runs",
  "v5.m2.tests.etat_cas.a_revalider": "to revalidate",
  "v5.m2.tests.etat_cas.brouillon": "draft",
  "v5.m2.tests.etat_cas.executable": "executable",
  "v5.m2.tests.import_echec": "The import failed.",
  "v5.m2.tests.importer": "Import",
  "v5.m2.tests.importer_titre": "Import cases from a job",
  "v5.m2.tests.importes": "{{nombre}} cases imported.",
  "v5.m2.tests.jamais_reussi": "A quarantined test never counts as passed.",
  "v5.m2.tests.lever": "Lift quarantine of {{cas}}",
  "v5.m2.tests.ligne_quarantaine": "{{cas}} — {{motif}} ({{qui}}, {{le}})",
  "v5.m2.tests.membres": "Project members",
  "v5.m2.tests.mettre_en_quarantaine": "Quarantine",
  "v5.m2.tests.motif_quarantaine": "Quarantine reason",
  "v5.m2.tests.nombre_cas": "{{nombre}} cases",
  "v5.m2.tests.non_acceptee": "not accepted",
  "v5.m2.tests.nouveau_cas": "New case",
  "v5.m2.tests.nouveau_plan": "New plan",
  "v5.m2.tests.onglet.campagnes": "Campaigns",
  "v5.m2.tests.onglet.cas": "Cases",
  "v5.m2.tests.onglet.essais": "Off-campaign runs",
  "v5.m2.tests.onglet.plans": "Plans",
  "v5.m2.tests.onglet.regression": "Regression report",
  "v5.m2.tests.onglet.tnr": "Regression suite",
  "v5.m2.tests.onglets": "Test views",
  "v5.m2.tests.ouvrir_plan_suite": "Open the suite plan",
  "v5.m2.tests.ouvrir_resultat": "Open the result",
  "v5.m2.tests.plan.active": "published",
  "v5.m2.tests.plan.archived": "archived",
  "v5.m2.tests.plan.draft": "draft",
  "v5.m2.tests.plans": "the plans",
  "v5.m2.tests.quarantaine": "Quarantine",
  "v5.m2.tests.quarantaine_echec": "The quarantine could not be changed.",
  "v5.m2.tests.quarantaine_levee": "Quarantine lifted.",
  "v5.m2.tests.quarantaine_posee": "Quarantine set.",
  "v5.m2.tests.rapport": "the regression report",
  "v5.m2.tests.rattacher": "Attach {{nombre}} cases to a plan",
  "v5.m2.tests.reference": "Reference: campaign no. {{id}}.",
  "v5.m2.tests.reference_a_choisir": "Reference: choose the current campaign first.",
  "v5.m2.tests.relance_echec": "The rerun failed.",
  "v5.m2.tests.relance_en_file": "Rerun queued.",
  "v5.m2.tests.relancer": "Rerun {{cas}}",
  "v5.m2.tests.resume_regressions": "{{non_acceptees}} unaccepted regressions, {{acceptees}} accepted.",
  "v5.m2.tests.selection_vide": "Select at least one case.",
  "v5.m2.tests.selectionner": "Select {{cas}}",
  "v5.m2.tests.suite": "the regression suite",
  "v5.m2.tests.suite_plan": "Plan “{{nom}}”, {{nombre}} cases included.",
  "v5.m2.tests.titre": "Tests",
  "v5.m2.tests.traitement": "Job identifier",
  "v5.m2.tests.traitement_requis": "Enter the job identifier."
}
